import React from 'react';
import { SimpleGrid, Title, Divider, Stack } from '@mantine/core';
import { NotificationsSettingsGlobalForm } from '../../components/NotificationsSettingsForm/NotificationsSettingsGlobalForm';
import { NotificationsSettingsEmailForm } from '../../components/NotificationsSettingsForm/NotificationsSettingsEmailForm';
import { DatabaseLock } from '../../components/DatabaseLock/DatabaseLock';

export const NotificationsSettings = () => {
  return (
    <Stack gap="xl">
      <Stack gap="sm">
        <Title order={3} c={'#322886'}>
          Globální nastavení
        </Title>
        <DatabaseLock />
      </Stack>

      <Divider my="sm" />

      <Title order={3} c={'#322886'}>
        Nastavení oznámení
      </Title>
      <SimpleGrid cols={2}>
        <NotificationsSettingsGlobalForm />
        <NotificationsSettingsEmailForm />
      </SimpleGrid>
    </Stack>
  );
};
